import styled from '@emotion/styled';

export const StyledGutter = styled.div(({ theme }) => ({
    [`@media (max-width: ${theme.sizes.contentMaxWidth}px)`]: {
        paddingLeft: 25,
        paddingRight: 25,
    },
}));
